import { render, staticRenderFns } from "./thematicGrEdit.vue?vue&type=template&id=1067ba9e&scoped=true"
import script from "./thematicGrEdit.vue?vue&type=script&lang=js"
export * from "./thematicGrEdit.vue?vue&type=script&lang=js"
import style0 from "./thematicGrEdit.vue?vue&type=style&index=0&id=1067ba9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1067ba9e",
  null
  
)

export default component.exports